import { FamilyModel } from '@modules/family/family-model';

const { fields } = FamilyModel;

export default [
    fields.gender,
    fields.children,
    fields.country,
    fields.email,
    fields.role,
    fields.birthdate,
];